import React, { Suspense, useState, useEffect } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Routes, Route } from "react-router-dom";
import { store, persistor } from "@/redux/store/store";
// import GlobalLoader from "@/components/common/loader/Loader";
import Loader from "components/loader/Loader";
import Notifications from "@/components/alertSnackbar/Notification";
import AppRoutes from "@/routes/AppRoutes";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import SocketProvider from "./context/SocketContext";
import ScreenSizeRestriction from "./components/dashboardComp/screenSizeRestriction/ScreenSizeRestriction";
import ErrorBoundaryWrapper from "./utils/errorBoundary";

// const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

function App() {
  const queryClient = new QueryClient();
  const [isAllowedScreenSize, setIsAllowedScreenSize] = useState(true);
  const MIN_SCREEN_WIDTH = 1024;
  const isDev = process.env.REACT_APP_ENV === "dev";

  useEffect(() => {
    const checkScreenSize = () => {
      setIsAllowedScreenSize(window.innerWidth >= MIN_SCREEN_WIDTH);
    };

    checkScreenSize();

    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);


    if ( !isAllowedScreenSize && !isDev) {
      return <ScreenSizeRestriction />;
    }

  const AppContent = (
    <Routes>
      <Route path="/*" element={<AppRoutes />} />
    </Routes>
  );

  return (
    <Provider store={store}>
      <SocketProvider>
        <PersistGate loading={null} persistor={persistor}>
          <Suspense fallback={ <Loader />}>
            <QueryClientProvider client={queryClient}>
              <Notifications />
              {isDev ? (
                AppContent
              ) : (
                <ErrorBoundaryWrapper>
                  {AppContent}
                </ErrorBoundaryWrapper>
              )}
            </QueryClientProvider>
          </Suspense>
        </PersistGate>
      </SocketProvider>
    </Provider>
  );
}

export default App;
